import script from "./DocumentForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentForm.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentForm.vue?vue&type=style&index=0&id=fccdc0b6&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fccdc0b6"]])

export default __exports__